import { render, staticRenderFns } from "./AnswerPublishedStatus.vue?vue&type=template&id=70a715ce&"
import script from "./AnswerPublishedStatus.vue?vue&type=script&lang=js&"
export * from "./AnswerPublishedStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports